import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class DriverLocationService {

	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {get} /v2/WorkOrders/:id/LastDriverLocation Get Drivers Last Location By Driver ID
	 * @apiName getDriversLastLocationByWorkOrderId
	 * @apiGroup WorkOrders
	 * @apiVersion 20.0.0
	 */
	getDriversLastLocationByWorkOrderId(workOrderId) {
		return this._http.get<any>(`${environment.apiUrl}/v2/WorkOrders/${workOrderId}/LastDriverLocation`);
	}
}
